var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',[_vm._v("Let’s see how P filled out his Bulls-I")]),_c('v-img',{staticClass:"mx-auto",attrs:{"max-width":300,"src":require('@/assets/MyBulls-i/bullsi_p.png'),"alt":"P's Bulls-I"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }